module.exports = __webpack_public_path__ + "img/filter-icon-one.7f6d3a25.svg";